// extracted by mini-css-extract-plugin
export default {"planetMintParis":"PlanetMintWithIdCard_planetMintParis__QlqxC"};